import React from 'react';
import HistoryContext from './HistoryContext';
import matchPath from './matchPath';
import RouterContext from './RouterContext';
var useContext = React.useContext;
export function useHistory() {
  return useContext(HistoryContext);
}
export function useLocation() {
  var _useContext;

  return (_useContext = useContext(RouterContext)) == null ? void 0 : _useContext.location;
}
export function useParams() {
  var _useContext2;

  var match = (_useContext2 = useContext(RouterContext)) == null ? void 0 : _useContext2.match;
  return match ? match.params : {};
}
export function useRouteMatch(path) {
  var _useContext3;

  var location = useLocation();
  var match = (_useContext3 = useContext(RouterContext)) == null ? void 0 : _useContext3.match;
  return path ? matchPath(location.pathname, path) : match;
}